module.exports = __webpack_public_path__ + "assets/f6384cabd9dff684aa6764724f3c9350.mp3";